import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginContainerComponent } from "./containers";

const routes: Routes = [{
  path: "",
  component: LoginContainerComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
